/* globals process */

import Vue from 'vue';

export default {
	namespaced: true,
	state() {
		return {
			users: {},
			opportunities: {},
			members: {},
			attachments: {},
			offices: {},
            events: {},
		}
	},
	mutations: {
		/**
		 *
		 * @param state
		 */
		clear(state) {
			state.users = {};
			state.opportunities = {};
			state.members = {};
			state.attachments = {};
			state.offices = {};
		},

		addUser(state, user) {
			if(!user || !user.id) {
				console.warn('UserDetail has no id');
				return;
			}

			Vue.set(state.users, user.id, user);
		},

		addMember(state, member) {
			if(!member || !member.id) {
				console.warn('Member has no id');
				return;
			}

			Vue.set(state.members, member.id, member);
		},

        addEvent(state, event) {
            if(!event || !event.id) {
                console.warn('Event has no id');
                return;
            }

            Vue.set(state.events, event.id, event);
        },

		addOpportunity(state, opportunity) {
			if(!opportunity || !opportunity.id) {
				console.warn('Opportunity has no id');
				return;
			}

			Vue.set(state.opportunities, opportunity.id, opportunity);
		},

		addAttachment(state, attachment) {
			if(!attachment || !attachment.uuid) {
				console.warn('Attachment has no uuid');
				return;
			}

			Vue.set(state.attachments, attachment.uuid, attachment);
		},

		addOffice(state, office) {
			if(!office || !office.id) {
				console.warn('Office has no id');
				return;
			}

			Vue.set(state.offices, office.id, office);
		}
	},
	getters: {
		getUser: state => id => {
			return state.users[id] || null;
		},

        getEvent: state => id => {
            return state.events[id] || null;
        },

		getMember: state => id => {
			return state.members[id] || null;
		},

		getOpportunity: state => id => {
			return state.opportunities[id] || null;
		},

		getAttachment: state => uuid => {
			return state.attachments[uuid] || null;
		},

		getOffice: state => id => {
			return state.offices[id] || null;
		},
	}
}
